// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconChevronLeft = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M24.3982 32C29.3199 27.4148 40.57 16.9339 41.2917 16.2615C42.2172 15.3992 42.2371 14.2786 41.3425 13.3841C40.448 12.4895 39.5104 11.5518 38.6159 10.6573C37.7214 9.76286 36.6007 9.78264 35.7384 10.7083C34.876 11.6338 17.9719 29.7786 17.1724 30.6366C16.3729 31.4947 16.3729 32.5052 17.1724 33.3633C17.9719 34.2215 34.876 52.3663 35.7384 53.2918C36.6007 54.2173 37.7213 54.2371 38.6159 53.3426C39.5104 52.448 40.448 51.5105 41.3425 50.616C42.237 49.7215 42.2172 48.6009 41.2916 47.7384C40.57 47.0661 29.3199 36.5851 24.3982 32Z" />
    </svg>
  );
};
